import wretch from "wretch";

export const fetchAPI = (pathname: string) => wretch().url(pathname);
